import { useState, useEffect } from "react";

// Estado global a nivel de módulo para compartir entre componentes
let deferredPrompt = null;
const listeners = new Set();

function notify() {
  listeners.forEach((fn) => fn(deferredPrompt));
}

// Capturar el evento una sola vez a nivel global
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  notify();
});

window.addEventListener("appinstalled", () => {
  deferredPrompt = null;
  notify();
});

// Detección de plataforma
const isStandalone =
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const isSafariDesktop =
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !isIOS;

const isSafari = isIOS || isSafariDesktop;

/**
 * Hook que expone el estado de instalación de la PWA.
 * Puede usarse simultáneamente en múltiples componentes.
 * @returns {{ canInstall: boolean, isSafari: boolean, isIOS: boolean, isStandalone: boolean, install: () => Promise<boolean> }}
 */
const useInstallPrompt = () => {
  const [prompt, setPrompt] = useState(deferredPrompt);

  useEffect(() => {
    const handler = (p) => setPrompt(p);
    listeners.add(handler);
    return () => listeners.delete(handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    notify();
    return outcome === "accepted";
  };

  // canInstall: prompt nativo disponible O es Safari y no está instalada aún
  const canInstall = !!prompt || (isSafari && !isStandalone);

  return { canInstall, isSafari, isIOS, isStandalone, install };
};

export default useInstallPrompt;
